import dynamic from "next/dynamic";
import RichTextBlogConfig from "./rich-text-blog-config";
import RichTextBlogAdvancedConfig from "./rich-text-blog-advanced-config";
const RichTextBlogComponent = dynamic(()=>import("./rich-text-blog-component"));
export default {
    RichTextBlogComponent,
    RichTextBlogConfig,
    RichTextBlogAdvancedConfig
};
